'use client';

import FilterIcon from '@repo/ui/src/components/Icons/FilterIcon';
import { useState } from 'react';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import FilterDrawer from './_FilterDrawer';

const GridHeader = ({ filters, currentFilters, setFilters, clearFilters, nbHits }) => {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-py-4 tw-px-8">
      <div>
        {filters && (
          <>
            <button onClick={() => setFiltersOpen(true)} className="tra-text-web-body-xl">
              <FilterIcon aria-hidden className="tw-mr-[1ch]" />
              {t('recipeCategory.filters', undefined, { default: 'Filters' })}
            </button>
            <FilterDrawer
              open={filtersOpen}
              onClose={() => setFiltersOpen(false)}
              filters={filters}
              currentFilters={currentFilters}
              setFilters={setFilters}
              clearFilters={clearFilters}
            />
          </>
        )}
      </div>
      <p className="tra-text-web-body-xl">
        {t('recipeCategory.results', { count: nbHits || 0 }, { default: '{{count}} Result' + (nbHits === 1 ? '' : 's') })}
      </p>
    </div>
  );
};

export default GridHeader;
